
  <mat-toolbar *ngIf="measureView=='before-measuring'" class="custom-toolbar">
    <button mat-icon-button class="white-icon" aria-label="back clicked" (click)="backClicked()">
      <mat-icon class="volume-icon">arrow_back</mat-icon>
    </button>
    <span class="toolbar-title">Measure Soil Moisture</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="white-icon" aria-label="read text" (click)="volumeClicked()">
      <mat-icon>volume_up</mat-icon>
    </button>
  </mat-toolbar>

  <div *ngIf="measureView=='before-measuring'" class="content-container" >
    <swiper class="swiper-container" [config]="config" [(index)]="index" [disabled]="disabled"
      (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
      (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="container text-area" fxLayout="column" fxFlexWrap fxLayoutAlign="space-evenly center" >
                <p class="title" >Step 1:</p>
                <p class="description">Get your sensor Ready</p>
              </div>
              <img src="../../../assets/crops-images/ms1.png" alt="Step 1:">
            </div>
            <h1>TEST</h1>
          </div>

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="text-area"  fxLayout="column" fxFlexFill fxLayoutAlign="center center" >
                <p class="title" textWrap="true">Step 2:</p>
                <p class="description" flex textWrap="false">Insert the sensor at least 15cm deep</p>
              </div>
              <img src="../../../assets/crops-images/ms2.png" alt="Step 2:">
            </div>
          </div>

          <div class="swiper-slide">
            <div class="container" fxLayout="column" fxFlexFill fxLayoutAlign="end center" >
              <div class="container text-area" fxLayout="column" fxFlexWrap fxLayoutAlign="space-evenly center" >
                <div class="image-cover">
                  <img mat-card-image class="cardImg" src="/assets/connect-to-sensor.png" alt="Connect to Sensor" />
                </div>
                <Label class="title" textWrap="true">Connect to Sensor</Label>
                <Label class="description" textWrap="true">How would you like to connect to your moisture sensor?</Label>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('usb')"><mat-icon>usb</mat-icon> Connect with USB
                </button>
                <button mat-flat-button class="c-btn" (click)="onSensorConnect('ble')">
                  <mat-icon>bluetooth</mat-icon> Connect with Bluetooth
                </button>
              </div>
            </div>
          </div>
    </swiper>
  </div>

  <div *ngIf="measureView=='measuring'"
       fxFlexFill fxLayout="column"
       fxLayoutGap="25px"
       fxLayoutAlign="center center">
      <div>
        <mat-spinner diameter="100" color="primary"></mat-spinner>
        <div style="position:relative; top: -60px; left: 45px;">{{countdownSecond}}</div>
      </div>
      <p>Reading...</p>
  </div>

  <div *ngIf="measureView=='after-measuring'"
       fxFlexFill fxLayout="column"
       fxLayoutGap="28px"
       fxLayoutAlign="center center">
    <img src="../../assets/low-moisture.png" alt="low-moisture">
    <p class="mat-body-1">SOIL MOISTURE</p>
    <p class="mat-display-1"><span style="color:red">{{ soilData.soilMoistureIndex }} </span> <span> {{soilData.soilMoisturePercentage}}% </span></p>
    <button mat-flat-button color="primary" (click)="onGetAdvise()">GET ADVISE</button>
  </div>
